import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { useProps } from "contexts/PropsContext"

import { ADMIN_LOCALES, LOCALE_NAMES } from "constants/locales"

import { Modal } from "./Modal"

interface LanguageModalProps {
  open: boolean
  onClose: () => void
}

export const LanguageModal = ({ open, onClose }: LanguageModalProps) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const { language, setLanguage } = useProps()

  const handleLanguageChange = (loc: string) => {
    setLanguage(loc)
    onClose()
  }

  return (
    <Modal open={open} handler={onClose}>
      <div className="relative flex flex-col modal-box bg-white dark:bg-[#0C0C1A] text-black dark:text-white" style={{ minWidth: 360 }}>
        <h3 className="font-bold text-lg mb-4">{t("settings.language")}</h3>
        <div className="flex flex-col gap-2">
          {ADMIN_LOCALES.map((loc) => (
            <button
              key={loc}
              className={clsx(
                "flex items-center justify-between px-4 py-3 rounded-lg border text-sm font-medium transition",
                language === loc
                  ? "border-[rgba(132,0,168,0.6)] bg-[rgba(132,0,168,0.08)]"
                  : "border-gray-200 dark:border-[rgba(255,255,255,0.1)] hover:bg-gray-50 dark:hover:bg-[#2a2b39]"
              )}
              onClick={() => handleLanguageChange(loc)}
            >
              <span>{LOCALE_NAMES[loc]}</span>
              {language === loc && <span className="text-[rgba(132,0,168,1)]">&#10003;</span>}
            </button>
          ))}
        </div>
        <div className="modal-action">
          <button className="btn btn-ghost btn-sm" onClick={onClose}>
            {t("settings.done")}
          </button>
        </div>
      </div>
    </Modal>
  )
}
